export default "__VITE_ASSET__9eClCjTU__"